import React from "react";
import "./Meet.css";
import FadeUp from "../FadeUp/FadeUp";

const Meet = ({ isAlbanian }) => {
  return (
    <div>
      <div className="meet-container">
        <div className="overlay">
          <div className="vertical-line left"></div>
          <div className="vertical-line right"></div>
          <div className="meet-content">
            {/* <div className='meet-little-tittle'>Life at Vila-l</div> */}
            <div
              className="meet-big-tittle"
            >
              <FadeUp>
              Meet our <span style={{ color: "red" }}>people</span>
              </FadeUp>
            </div>
            <FadeUp>
            <div
              className="meet-photos"
            >
              <div className="meet-card">
                <img
                  src="./coneng.jpg"
                  alt="employee"
                  className="meet-first-photo"
                />
                <div className="meet-overlay">
                  <div className="meet-role">{isAlbanian ? "Administrator" : "Administrator"}</div>
                  <div className="meet-name">Lazër Mhilli</div>
                  <div className="additional-text"></div>
                </div>
              </div>
              <div className="meet-card-second">
                <img
                  src="./coneng.jpg"
                  alt="employee"
                  className="meet-first-photo"
                />
                <div className="meet-overlay">
                  <div className="meet-role">{isAlbanian ? "Arkitekt" : "Architect"}</div>
                  <div className="meet-name">Gentian Mhilli</div>
                  <div className="additional-text"></div>
                </div>
              </div>
              <div className="meet-card-third">
                <img
                  src="./coneng.jpg"
                  alt="employee"
                  className="meet-first-photo"
                />
                <div className="meet-overlay">
                  <div className="meet-role">{isAlbanian ? "Arkitekt" : "Architect"}</div>
                  <div className="meet-name">Xhevit Petoshati</div>
                  <div className="additional-text"></div>
                </div>
              </div>
              <div className="meet-card-fourth">
                <img
                  src="./coneng.jpg"
                  alt="employee"
                  className="meet-first-photo"
                />
                <div className="meet-overlay-fourth">
                  <div className="meet-role">{isAlbanian ? "Inxhinier Ndërtimi" : "Construction Engineer"}</div>
                  <div className="meet-name">Kreshnik Curri</div>
                  <div className="additional-text"></div>
                </div>
              </div>
            </div>
            </FadeUp>
          </div>
          <div className="bottom-line"></div>
        </div>
      </div>
    </div>
  );
};

export default Meet;
